module.exports = __webpack_public_path__ + "static/img/spring_tab1_select.f116881.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab1_select.png
// module id = 356
// module chunks = 32